<template>
  <NuxtLinkLocale
    v-if="props.internal"
    :to="props.href"
    class="btn btn-primary w-100 mb-3"
    role="button"
  >
    <slot mdc-unwrap="p" />
  </NuxtLinkLocale>
  <a
    v-else
    :href="props.href"
    target="_blank"
    rel="noopener noreferrer"
    class="btn btn-primary w-100 mb-3"
    role="button"
  >
    <slot mdc-unwrap="p" />
  </a>
</template>

<script setup lang="ts">
const props = defineProps({
  href: {
    type: String
  },
  internal: {
    type: Boolean,
    default: false
  }
})
</script>
